module.exports = __webpack_public_path__ + "media/images/pic/brodno/hero_bg-bcfa3eb41d9630f2c24185b03443843f.png";